import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheCommandCenter from "./sections/TheCommandCenter";
import VisualLog from "./sections/VisualLog";
import TheStack from "./sections/TheStack";
import HubImpact from "./sections/HubImpact";
import OpenSourceToolkit from "./sections/OpenSourceToolkit";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheCommandCenter />
      <VisualLog />
      <TheStack />
      <HubImpact />
      <OpenSourceToolkit />
      <Footer />
    </div>;
}